import React from 'react';

function JobBoard({ onClose }) {
  const mockJobs = [
    { title: 'Software Engineer', company: 'TechCorp', location: 'Remote', source: 'LinkedIn', salary: '$80k-120k' },
    { title: 'Data Scientist', company: 'DataInc', location: 'New York', source: 'Indeed', salary: '$95k-140k' },
    { title: 'Product Manager', company: 'StartupXYZ', location: 'San Francisco', source: 'LinkedIn', salary: '$110k-160k' },
    { title: 'UX Designer', company: 'DesignStudio', location: 'Austin', source: 'Indeed', salary: '$70k-100k' },
    { title: 'Financial Analyst', company: 'FinanceGroup', location: 'Chicago', source: 'LinkedIn', salary: '$65k-90k' }
  ];

  const applyToJob = (title, company) => {
    alert(`Redirecting to apply for ${title} at ${company}...`);
  };

  return (
    <section id="job-board-section">
      <h2>Job Opportunities</h2>
      <div id="job-board-content">
        <div className="job-board-header">
          <h3>Latest Job Opportunities</h3>
          <p>Powered by LinkedIn and Indeed APIs</p>
        </div>
        {mockJobs.map((job, index) => (
          <div key={index} className="job-listing">
            <div className="job-details">
              <h4>{job.title}</h4>
              <p><strong>{job.company}</strong> • {job.location}</p>
              <p className="job-salary">{job.salary}</p>
            </div>
            <div className="job-actions">
              <span className="job-source">{job.source}</span>
              <button 
                onClick={() => applyToJob(job.title, job.company)} 
                className="apply-btn"
              >
                Apply
              </button>
            </div>
          </div>
        ))}
      </div>
      <button onClick={onClose}>Close</button>
    </section>
  );
}

export default JobBoard;